export enum CopywriterAnalitycsEventType {
  PAGE_OPEN = 'page_open',
  TOOL_SELECT = 'tool_select',
  CTA_CLICK = 'cta_click',
  TEXT_BOX_CLICK = 'text_box_click',
  TEXT_BOX_TYPE = 'text_box_type',
  TAB_SELECT = 'tab_select',
  GENERATE = 'generate',
  TEXT_GENERATED = 'text_generated',
  RESULT_ACTION = 'results_action',
  GENERATE_MORE = 'generate_more',
  TEXT_COPY_CONVERSATION = 'text_copy_conversion',
  PAGE_CLICK = 'page_click',
  REPHRASE_THIS = 'rephrase_this',
}

export type CtaClickParams = {
  page_path: string;
  information?: string;
  action_type: string;
};

export type TextBoxClickParams = {
  page_path: string;
  text_box_name: string;
  category_name: string;
};
export type TextBoxTypeParams = TextBoxClickParams;

export type TabSelectParam = {
  page_path: string;
  action_type: string;
  category_name: string;
  section_type?: string;
};
export type PageClickParam = TabSelectParam;

export type ResultsActionParam = TabSelectParam;

export type CopyParams = {
  page_path: string;
  action_type: string;
  category_name: string;
  copied_text: Record<string, string>;
  text_category: string;
};

export type TokenInformation = {
  prompt_tokens: number;
  completion_tokens: number;
};

export type TextGeneratedParam = {
  page_path: string;
  text_information: string[];
  category_name: string;
  token_information: TokenInformation;
};
export type GenerateParam = {
  page_path: string;
  text_information: Record<string, string>;
  category_name: string;
};

export type RephraseThisParam = {
  page_path: string;
  text_to_rephrase: string;
  category_name: string;
  token_information: TokenInformation;
};

export type ToolSelectParam = {
  page_path: string;
  action_type: string;
  button_type?: string;
};

export type GenerateMoreParam = GenerateParam;
